export const visualizer = {
    devices: {
        breakPoints: {
            large: 1200,
            medium: 768,
            small: 576,
        }
    }
}
